import {
  RESET_TABS,
  RESET_TAB,
  RESET_ERROR,
  GET_TABS,
  SET_TABS,
  API_ERROR,
  CREATE_TAB,
  CREATE_TAB_SUCCESS,
  GET_TAB,
  SET_TAB,
  EDIT_TAB,
  EDIT_TAB_SUCCESS,
  DELETE_TAB,
  DELETE_TAB_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorTab: false,
  loadingTab: false,
  dataTab: null,
  successTab: false,
};

const Tab = (state = initialState, action) => {
  switch (action.type) {
    case RESET_TABS:
      state = {
        ...state,
        errorTab: false,
        loadingTab: false,
        loadingTabDelete: false,
        successTab: false,
        dataTab: null,
        dataTabDelete: null,
      };
      break;
    case RESET_TAB:
      state = {
        ...state,
        errorTab: false,
        loadingTab: false,
        successTab: false,
        dataTabGetSet: null,
        dataTabEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorTab: false,
        loadingTab: false,
        loadingTabEditCreate: false,
        loadingTabActivate: false,
        successTab: false,
      };
      break;
    case GET_TABS:
      state = {
        ...state,
        errorTab: false,
        loadingTab: true,
        dataTab: null,
      };
      break;
    case SET_TABS:
      state = {
        ...state,
        errorTab: false,
        loadingTab: false,
        dataTab: action.payload,
      };
      break;
    case CREATE_TAB:
      state = {
        ...state,
        errorTab: false,
        loadingTabEditCreate: true,
        dataTabEditCreate: action.payload,
        successTab: false,
      };
      break;
    case CREATE_TAB_SUCCESS:
      state = {
        ...state,
        errorTab: false,
        loadingTabEditCreate: false,
        dataTabEditCreate: action.payload,
        successTab: true,
      };
      break;
    case GET_TAB:
      state = {
        ...state,
        errorTab: false,
        loadingTab: true,
        dataTabGetSet: null,
      };
      break;
    case SET_TAB:
      state = {
        ...state,
        errorTab: false,
        loadingTab: false,
        dataTabGetSet: action.payload,
      };
      break;
    case EDIT_TAB:
      state = {
        ...state,
        errorTab: false,
        loadingTabEditCreate: true,
        dataTabEditCreate: action.payload,
        successTab: false,
      };
      break;
    case EDIT_TAB_SUCCESS:
      state = {
        ...state,
        errorTab: false,
        loadingTabEditCreate: false,
        dataTabEditCreate: action.payload,
        successTab: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorTab: action.payload,
        loadingTab: false,
        loadingTabDelete: false,
        successTab: false,
      };
      break;
    case DELETE_TAB:
      state = {
        ...state,
        errorTab: false,
        loadingTabDelete: true,
        dataTabDelete: action.payload,
        successTab: false,
      };
      break;
    case DELETE_TAB_SUCCESS:
      state = {
        ...state,
        errorTab: false,
        loadingTabDelete: false,
        dataTabDelete: action.payload,
        successTab: true,
      };
      break;
    default:
      // state = { ...state, errorTab: false, loadingTab: false };
      break;
  }
  return state;
};

export default Tab;
